module.exports = __webpack_public_path__ + "static/media/L-8.5be1f52e.svg";